import { useTranslation } from 'react-i18next';

interface PlaceholderSectionProps {
  titleKey?: string;
}

export function PlaceholderSection({ titleKey }: PlaceholderSectionProps) {
  const { t } = useTranslation('settings');

  return (
    <div
      className="flex flex-col items-center justify-center h-full gap-3 py-16 text-center"
      data-testid="settings-placeholder-section"
    >
      <p className="text-base font-semibold text-foreground">
        {titleKey ? t(titleKey) : t('placeholder.title')}
      </p>
      <p className="text-sm text-muted-foreground max-w-xs">{t('placeholder.description')}</p>
    </div>
  );
}
